import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/transactionList',
        name: 'transactionList',
        component: () => import('../views/transactionList.vue')
    },
    {
        path: '/ETSL',
        name: 'ETSL',
        component: () => import('../views/ETSL.vue')
    },
    {
        path: '/MPL',
        name: 'MPL',
        component: () => import('../views/MPL.vue')
    },
    {
        path: '/pps',
        name: 'pps',
        component: () => import('../views/pps.vue')
    },
    {
        path: '/PPS2',
        name: 'PPS2',
        component: () => import('../views/PPS2.vue')
    },
    {
        path: '/CMC',
        name: 'CMC',
        component: () => import('../views/CMC.vue')
    },
    {
        path: '/FCT',
        name: 'FCT',
        component: () => import('../views/FCT.vue')
    },
    {
        path: '/NBC',
        name: 'NBC',
        component: () => import('../views/NBC.vue')
    },
    {
        path: '/NBA',
        name: 'NBA',
        component: () => import('../views/NBA.vue')
    },
    {
        path: '/NBC3',
        name: 'NBC3',
        component: () => import('../views/NBB.vue')
    },
    {
        path: '/FGC',
        name: 'FGC',
        component: () => import('../views/FGC.vue')
    },
    {
        path: '/FGC3',
        name: 'FGC3',
        component: () => import('../views/FGC3.vue')
    },
    {
        path: '/NBC33',
        name: 'NBC33',
        component: () => import('../views/NBC33.vue')
    },
    {
        path: '/ETHC',
        name: 'ETHC',
        component: () => import('../views/ETHC.vue')
    },
    {
        path: '/EUSD',
        name: 'EUSD',
        component: () => import('../views/EUSD.vue')
    },
    {
        path: '/transactionDetail',
        name: 'transactionDetail',
        component: () => import('../views/transactionDetail.vue')
    },
    {
        path: '/blockList',
        name: 'blockList',
        component: () => import('../views/blockList.vue')
    },
    {
        path: '/blockDetail',
        name: 'blockDetail',
        component: () => import('../views/blockDetail.vue')
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
